import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types'
import {Helmet} from 'react-helmet';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {getSidebarContent} from '../../Content/actions';
import ReactHtmlParser from 'react-html-parser';
import SectionTitle from '../../Layout/components/SectionTitle';
import ContactForm from './ContactForm';
import LoadingSpinner from '../../Layout/components/LoadingSpinner';

class ContactContainer extends Component {
    componentDidMount() {
        this.props.getSidebarContent('ifp_contact');
    }

    render() {
        const {sidebar, loading} = this.props;

        const pageTitle = process.env.REACT_APP_SITE_TITLE + ' | Contactez-nous';

        if (sidebar.ifp_contact === null || sidebar.ifp_contact === undefined || loading) {
            return (
                <Fragment>
                    <Helmet
                        bodyAttributes={{
                            class: 'contact vertical-content-force-height-100'
                        }}
                    >
                        <title>{pageTitle}</title>
                    </Helmet>
                    <div className="container">
                        <div className="row mt-0 mb-0 align-items-center" style={{height: '100%'}}>
                            <div className="col-3 mx-auto">
                                <div className="text-center">
                                    <LoadingSpinner/>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            );
        }

        let widgets = sidebar.ifp_contact.widgets;

        let title = <Fragment>{ReactHtmlParser(widgets.titre.data.content)}</Fragment>;

        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'contact'
                    }}
                >
                    <title>{pageTitle}</title>
                </Helmet>
                <div className="container">
                    <SectionTitle cssClass="page-title" title={title} subtitle={widgets.description.data.content} />

                    <div className="mt-30 mb-30 mt-lg-90 mb-lg-90">
                        <ContactForm/>
                    </div>
                </div>
            </Fragment>
        );
    }
}

ContactContainer.propTypes = {
    getSidebarContent: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    sidebar: state.content.sidebar,
    loading: state.content.sidebarLoading,
    errors: state.errors,
});

export default withRouter(connect(mapStateToProps, {getSidebarContent})(ContactContainer));



// WEBPACK FOOTER //
// ./src/features/Contact/components/ContactContainer.js